import { render, staticRenderFns } from "./SinglePicOrPdfCard.vue?vue&type=template&id=340e3112&scoped=true"
import script from "./SinglePicOrPdfCard.vue?vue&type=script&lang=js"
export * from "./SinglePicOrPdfCard.vue?vue&type=script&lang=js"
import style0 from "./SinglePicOrPdfCard.vue?vue&type=style&index=0&id=340e3112&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@0.28.11_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.99.6_webpack-cli@4.10.0_/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340e3112",
  null
  
)

export default component.exports